<!--
 * @Desc: 全局搜索
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-09 08:34:39
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-school-news">
        <!-- 菜单 -->
        <menuCommon :active="active"></menuCommon>
        <!-- 内容区 -->
        <section class="school-news">
            <div class="container">
                <!-- <RecommendedRead></RecommendedRead> -->
                <div style="height:30px;"></div>
                <div class="news-hold">
                    <MenuVertical :active="active"></MenuVertical>
                    <div class="news-list">
                        <el-empty description="暂无数据" v-if="tableData && tableData.length == 0"></el-empty>
                        <div class="news-item" v-for="(item,idx) in tableData" :key="item.id" @click="toDetail(item)">
                            <div class="thu-hold">
                                <img
                                    class="thu"
                                    :src="$adddom(item.thumb)"
                                />
                                <div class="time">
                                    <p>{{ timestampToTime(item.publish_at,6) }}</p>
                                    {{ timestampToTime(item.publish_at,5) }}
                                </div>
                            </div>
                            <div class="news-info">
                                <div class="title ellipsis1">
                                    {{ item.title }}
                                </div>
                                <div class="desc ellipsis2">
                                    {{ item.keywords }}
                                </div>
                                <div class="time">{{ timestampToTime(item.publish_at,1) }}</div>
                            </div>
                        </div>
                        <div class="pagination" v-if="queryParam.total>0">
                            <el-pagination
                                background
                                @current-change="handleQueryEvent"
                                :current-page.sync="queryParam.page"
                                :page-size="queryParam.size"
                                layout="prev, pager, next, jumper"
                                :total="queryParam.total"
                            >
                            </el-pagination>
                        </div>
                    </div>
                    <div class="recommend-list">
                        <LastRecommend :recommendData="recommendData"></LastRecommend>
                    </div>
                </div>
            </div>
        </section>
        <!-- 页脚 -->
        <footerCommon></footerCommon>
    </div>
</template>

<script>
import utils from "@/api/Utils.js"
import menuCommon from "./../components/Common/Menu.vue";
import footerCommon from "./../components/Common/Footer.vue";
import BreadCrumb from "./../components/Common/BreadCrumb.vue";
import RecommendedRead from "./../components/Common/RecommendedRead.vue";
import MenuVertical from "./../components/Common/MenuVertical.vue";
import LastRecommend from "./../components/Common/LastRecommend.vue";
export default {
    name: "home",
    data() {
        return {
            // 菜单选中
            active: this.$route.query.active,
            recommendData:{},
            // 栏目详情
            cateData:'',
            // 面包屑展示数据
            objectData: {
                title: "",
                navArray: [
                ],
                thu:''
            },
            // 顶部图片
            imageUrl: require("../../public/statics/images/Banner/banner1.jpg"),
            queryParam: {
                ks_id: "",
                total: 0,
                page: 1,
                size: 10,
            },
            tableData:''
        };
    },
    components: {
        menuCommon,
        footerCommon,
        BreadCrumb,
        RecommendedRead,
        MenuVertical,
        LastRecommend,
    },
    watch:{
        $route(val){
            this.active = this.$route.query.active
            this.searchClick()
        }
    },
    created() {
        this.searchClick()
    },
    mounted() {
        $("html,body").scrollTop(0);
    },
    beforeDestroy() {},
    methods: {
        // 格式化时间
        timestampToTime(timestamp, type){
            return utils.timestampToTime(timestamp, type)
        },
        /**
         * @name: 跳转详情
         * @param {*} item
         * @return {*}
         * @desc: 跳转详情
         */        
        toDetail(item){
            console.log(item)
            this.$toPath('/NewsDetail?active='+this.active+'&id=' +item.id)
        },
        /**
         * @name: 搜索
         * @return {*}
         * @desc: 
         */        
         searchClick() {
            this.queryParam.page = 1;
            this.handleQueryEvent();
        },
        /**
         * @name: 调用接口 查询数据
         * @return {*}
         * @desc: 
         */        
        handleQueryEvent() {
            // 调用接口
            console.log("调用接口");
            let that = this
            that.$api.index.search({key:this.$route.query.key}).then((res) => {
                if (res.code == 200) {
                    // console.log(res)
                    that.tableData = res.result.list
                    that.queryParam.total = res.result.total
                }
            })
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-school-news {
    background: #f0f2f5 no-repeat top center;
}
/*  */
.page-school-news .school-news .container .news-hold {
    display: flex;
    flex-direction: row;
    overflow: hidden;
    margin-bottom: 30px;
}
.page-school-news .container .news-hold .news-list {
    flex: 1;
    background: #ffffff;
    padding: 16px;
}
.page-school-news .news-hold .news-list .news-item {
    display: flex;
    margin-bottom: 24px;
    cursor: pointer;
}
.page-school-news .news-hold .news-list .news-item .thu-hold {
    width: 220px;
    height: 150px;
    position: relative;
    margin-right: 24px;
    overflow: hidden;
}
.page-school-news .news-hold .news-list .news-item .thu-hold .thu {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.page-school-news .news-hold .news-list .news-item .thu-hold .time {
    width: 50px;
    height: 50px;
    background: #d62116;
    font-size: 12px;
    line-height: 12px;
    font-family: DINCondensed-Bold, DINCondensed;
    font-weight: bold;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 5px;
    position: absolute;
    top: 10px;
    left: 10px;
}
.page-school-news .news-hold .news-list .news-item .thu-hold .time p {
    font-size: 24px;
    line-height: 20px;
}
.page-school-news .news-hold .news-list .news-item .news-info {
    width: 360px;
    flex: 1;
    padding-top: 24px;
}
.page-school-news .news-hold .news-list .news-item .news-info .title {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 25px;
    color: rgba(51, 51, 51, 1);
}
.page-school-news .news-hold .news-list .news-item .news-info .desc {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(0, 0, 0, 1);
    height: 44px;
    margin-top: 18px;
    margin-bottom: 10px;
}
.page-school-news .news-hold .news-list .news-item .news-info .time {
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 24px;
    color: rgba(173, 180, 199, 1);
}
/* 滑入 */
.page-school-news .news-hold .news-list .news-item:hover .news-info .title{
    color: #e22f24;
}
.page-school-news .news-hold .news-list .news-item:hover .thu-hold .thu{
    transform: scale(1.2);
}
.page-school-news .pagination {
    text-align: center;
    margin: 60px 0;
}
.page-school-news
    /deep/
    .el-pagination.is-background
    .el-pager
    li:not(.disabled).active {
    background: #e22f24;
}
/*  */
.page-school-news .container .news-hold .recommend-list {
    width: 394px;
    background: #ffffff;
    padding-left: 50px;
    padding-top: 16px;
}
</style>